export default __webpack_public_path__ + "90efee8db5fffc74d44f8d81020f70a7.png";